/* global rp$, $ajax */
'use strict';

require('public/js/elements/overlay-spinner');

const utils = require('public/js/helpers/utils');
const {
	getInventoryMessage,
	getShippingMessage,
	getShippingMessageTitle,
	getShippingEstimateMessage,
	getPickupMessage,
	getInventoryMessageCustomerId,
	getInventoryMessageWarehouseId,
} = require('public/js/lib/product-message-utils');

const FIT_PART_RECOMMENDATION_EVENT_PREFIX = 'fit_part_recommendation';

function initBrowseFittingProducts($container) {
	let tracking_page = globalThis?.tracking?.page || 'other';
	let productDetail = globalThis?.tracking?.ec;

	let $partFitmentInfoElement = $container.find('#part-fitment-info');
	if ($partFitmentInfoElement.length) {
		let data = $partFitmentInfoElement.data('fitment-info');
		if (data === 'part-doesnt-fit') {
			globalThis.rp_app.track.track_event(['ProductPageWrongCarSelected', 'WrongCarSelected', tracking_page]);
		}
	}

	let $productLink = $container.find('.suggested-products');
	if ($productLink.length) {
		$productLink.on('click', function (e) {
			globalThis.rp_app.track.track_event(['ProductPageWrongCarSelected', 'SuggestedProductClick', tracking_page]);

			let $card = rp$(this);
			let basePayload = {
				item_id: productDetail ? productDetail.id : undefined,
				item_name: productDetail ? productDetail.name : undefined,
				suggested_item_id: $card.find('[data-test-id="suggested-product__sku"]').first().text().trim(),
				suggested_item_name: $card.find('[data-test-id="suggested-product__name"]').first().text().trim() || undefined,
			};

			let isAddToCart = e.target.closest('.fitting-product-add-cart');
			let $link = rp$(e.target).closest('a.suggested-product-link');

			let payload = Object.assign({}, basePayload, {
				click_target: isAddToCart ? 'add_to_cart' : 'product_link',
				link_url: $link.length ? $link.attr('href') : null,
			});

			globalThis.rp_app.track.track_ec_general(FIT_PART_RECOMMENDATION_EVENT_PREFIX + '_click', payload);
		});
	}

	let $addCartButton = $container.find('.fitting-product-add-cart');
	if ($addCartButton.length) {
		$addCartButton.on('click', function () {
			globalThis.rp_app.track.track_event(['ProductPageWrongCarSelected', 'SuggestedProductAddToCartClick', tracking_page]);
		});
	}

	let $productsThatFitElement = $container.find('.fitting-products');
	if ($productsThatFitElement.length === 0) {
		return;
	}

	let fittingProductCount = $productsThatFitElement.children().length;
	let redesign = $container.find('.browse-fitting-products').hasClass('redesign');
	$productsThatFitElement.owlCarousel({
		margin: 10,
		nav: true,
		navText: false,
		dots: !redesign,
		responsive: {
			0: { items: 1 },
			640: { items: redesign ? 2 : 1 },
			767: { items: 1 }
		},
		loop: true,
	});

	$container.find('.browse-fitting-products').attr('hidden', false);
	$container.find('.browse-fitting-products').show(500, function () {
		$container.find('.fitting-products').attr('hidden', false);
		$container.find('.fitting-products-header').attr('hidden', false);
		$productsThatFitElement.trigger('refresh.owl.carousel');

		if (fittingProductCount > 0) {
			globalThis.rp_app.track.track_ec_general(FIT_PART_RECOMMENDATION_EVENT_PREFIX + '_view', {
				item_id: productDetail ? productDetail.id : undefined,
				item_name: productDetail ? productDetail.name : undefined,
				count: fittingProductCount,
			});
		}
	});
}

function loadInventoryMessages($container) {
	let $inventoryModule = $container.find('.product-inventory-msg');
	if ($inventoryModule.length === 0) {
		return;
	}

	let catalog = $inventoryModule.data('catalog');
	let skuStripped = $inventoryModule.data('sku-stripped');
	let inStock = $inventoryModule.data('in-stock');
	let price = $inventoryModule.data('price');
	let quantity = $inventoryModule.data('quantity');
	let isVariantMaster = $inventoryModule.data('is-variant-master');
	let inventoryWarehouseId = $inventoryModule.data('inventory-warehouse-id');
	let inventoryCustomerId = $inventoryModule.data('inventory-customer-id');

	if (!catalog || !skuStripped || isVariantMaster || !inventoryWarehouseId || !inventoryCustomerId) {
		return;
	}

	$ajax({
		method: 'GET',
		dataType: 'json',
		url: '/ajax/product/get-inventory-messaging',
		data: {
			catalog: catalog,
			sku: skuStripped,
			stock: inStock,
			price: price,
			quantity: quantity,
			inventoryWarehouseId: inventoryWarehouseId,
			inventoryCustomerId: inventoryCustomerId,
		},
		success: function (message) {
			if (!message) {
				return;
			}

			let responseInventoryMessage = getInventoryMessage(message);
			let responseShippingMessage = getShippingMessage(message);
			let responseShippingMessageTitle = getShippingMessageTitle(message);
			let responseShippingEstimateMessage = getShippingEstimateMessage(message);
			let responsePickupMessage = getPickupMessage(message);
			let responseInventoryType = message.inventoryMessageType || '';

			$container.find('#rp_inventory_message').html(responseInventoryMessage);
			$container.find('#rp_shipping_message').html(responseShippingMessage);
			$container.find('.shipping-message-title').html(responseShippingMessageTitle);
			$container.find('#rp_shipping_estimate_message').html(responseShippingEstimateMessage);
			$container.find('#rp_pickup_message').html(responsePickupMessage);

			let $inventoryWrap = $container.find('#inventory_wrap');
			$inventoryWrap.removeClass('inventory-out-of-stock');
			if (responseInventoryType === 'OutOfStockMessagingOnly') {
				$inventoryWrap.addClass('inventory-out-of-stock');
			}

			$container.find('.shipping-message-section').attr('hidden', responseShippingEstimateMessage === '' && responseShippingMessage === '');
			$container.find('#rp_shipping_message').attr('hidden', responseShippingMessage === '');
			$container.find('#rp_shipping_estimate_message').attr('hidden', responseShippingEstimateMessage === '');
			$container.find('.shipping-estimate-message-helptext').attr('hidden', responseShippingEstimateMessage === '');
			$container.find('.pickup-message-section').attr('hidden', responsePickupMessage === '');
			$inventoryWrap.attr('hidden', responseInventoryMessage === '');

			if (responseShippingEstimateMessage !== '') {
				let responseCustomerId = getInventoryMessageCustomerId(message);
				let responseWarehouseId = getInventoryMessageWarehouseId(message);
				$container.find('#rp_shipping_estimate_message').attr('data-inventory-warehouse-id', responseWarehouseId);
				$container.find('#rp_shipping_estimate_message').attr('data-inventory-warehouse-customer-id', responseCustomerId);
			}

			let $inStockBadge = $container.find('.badge-instock');
			let $shippingIcon = $container.find('.shipping-icon');
			if (responseInventoryMessage !== '') {
				$inStockBadge.attr('hidden', false);
				$shippingIcon.attr('hidden', false);
			}
		}
	});
}

let THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	(function LoadFitmentConfirmationModule() {
		$onReady({
			rp$, window,
			label: 'load_fitment_confirmation',
			fn: function () {
				let $wrappers = rp$('.fitment-confirmation-component-ajax-wrapper');
				if ($wrappers.length === 0 || utils.isBot()) {
					return;
				}

				$wrappers.each(function () {
					let $target = rp$(this);
					let catalog = $target.data('catalog');
					let mpn = $target.data('mpn');

					if (!catalog || !mpn) {
						return;
					}

					let productPageUrl = window.location.pathname;
					let inlineChangeLinkAttr = $target.attr('data-inline-change-link');
					let inlineChangeLink = inlineChangeLinkAttr !== '0' && inlineChangeLinkAttr !== 'false';
					let inventoryProductAttr = $target.attr('data-inventory-product');
					let inventoryProduct = inventoryProductAttr ? JSON.parse(inventoryProductAttr) : [];
					const encodedInventory = encodeURIComponent(JSON.stringify(inventoryProduct));


					$ajax({
						method: 'GET',
						dataType: 'json',
						url: '/ajax/product/' + encodeURIComponent(catalog) + '/' + encodeURIComponent(mpn) + '/fits-my-vehicle',
						data: {
							productPageUrl: productPageUrl,
							inlineChangeLink: inlineChangeLink ? '1' : '0',
							inventoryProduct: encodedInventory,
						},
						cache: false,
						success: function (response) {
							if (response && response.html) {
								$target.html(response.html);
								initBrowseFittingProducts($target);
								loadInventoryMessages($target);
							}
						},
						error: function () {
							$target.empty();
						}
					});
				});
			}
		});
	})();
};

try {
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
